/**
 * escapeOutput
 *
 * @param str
 * @returns {*|string}
 */
export function escapeOutput(str) {

    if (!str === undefined || typeof str !== 'string') {
        return '';
    }

    return str.replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#x27')
        .replaceAll("//", '&#x2F');
}

/**
 * unEscapeOutput
 *
 * @param toOutput
 * @returns {*|string}
 */
export function unEscapeOutput(toOutput) {

    if (!toOutput === undefined || typeof toOutput !== 'string') {
        return '';
    }

    toOutput = toOutput.toString();

    return toOutput.replaceAll('&amp;', '&')
        .replaceAll('&lt;', '<')
        .replaceAll('&gt;', '>')
        .replaceAll('&quot;', '"')
        .replaceAll("&#x27", "'")
        .replaceAll("&#x2F", '//');
}
